/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Coaches_TitleInputs */

const en_portal_coaches_title = /** @type {(inputs: Portal_Coaches_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find a coach`)
};

const pl_portal_coaches_title = /** @type {(inputs: Portal_Coaches_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Znajdź trenera`)
};

/**
* | output |
* | --- |
* | "Find a coach" |
*
* @param {Portal_Coaches_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_coaches_title = /** @type {((inputs?: Portal_Coaches_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Coaches_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_coaches_title(inputs)
	return en_portal_coaches_title(inputs)
});